module.exports = __webpack_public_path__ + "media/images/contest-label-right-bc796412052d212a15e2dad26b0fdfaf.png";